import React from 'react';
import { string } from 'prop-types';

const TileHead = ({ title, icon }) => {

  return (
    <div className="fulfillment__head">
      <span className="u__bold">{title}</span>
      { icon && (<span className={`fulfillment__icon ${icon}`} />)}
    </div>
  );
};
TileHead.propTypes = {
  title: string,
  icon: string
};
TileHead.defaultProps = {
  title: '',
  icon: ''
};

export { TileHead };
